import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { MultiSelect } from 'components/MultiSelect/MultiSelect'
import { translate } from 'i18n/i18n'
import { useEffect } from 'react'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { mapControlsStore } from 'stores/mapControlsStore/mapControlsStore'
import { mapSelectedCardStore } from 'stores/mapSelectedCardStore/mapSelectedCardStore'
import { getPrimaryValueGroup } from 'stores/selectedValueGroupsStore/getPrimaryValueGroup'
import { withoutPrePostFilterEmitterTypes } from 'utils/isPrePostFilterEmitterType'
import { mapApiEmitterTypeToLabel } from 'utils/mapApiEmitterTypeToLabel'
import { sortByKey } from 'utils/sortByKey'

export const EmitterMultiSelect = () => {
  const { properties } = fieldAssetStore.useSelector((s) => s)
  const selectedEmitters = mapControlsStore.useSelector((s) => s.selectedEmitters)
  const primaryValueGroup = getPrimaryValueGroup()

  const availableEmittersSet = [
    ...new Set<TEmitterType>(
      Object.values(properties ?? {}).flatMap((property) =>
        property.points
          ? Object.values(property.points).flatMap((pt) =>
              withoutPrePostFilterEmitterTypes(pt.configuration.irrigationEmitterTypesAvailable),
            )
          : [],
      ),
    ),
  ]

  useEffect(() => {
    if (primaryValueGroup === 'irrigation_activity_zones') {
      mapControlsStore.setState((s) => ({
        ...s,
        selectedEmitters: availableEmittersSet,
      }))
    }
  }, [primaryValueGroup])

  return (
    <MultiSelect
      data={availableEmittersSet
        .map((emitter) => ({
          label: mapApiEmitterTypeToLabel(emitter),
          value: emitter,
        }))
        .sort(sortByKey('label'))}
      onChange={(items) => {
        mapControlsStore.setState((s) => ({
          ...s,
          selectedEmitters: items.map((item) => item.value as TEmitterType),
        }))

        mapSelectedCardStore.actions.hide()
      }}
      placeholder={translate.phrases.banyanApp('Select Emitters')}
      selectedData={selectedEmitters
        .map((emitter) => ({
          label: mapApiEmitterTypeToLabel(emitter),
          value: emitter,
        }))
        .sort(sortByKey('label'))}
    />
  )
}
